"use client"

import { useState, useContext, useEffect } from "react"
import { ErpContext } from "../../context/ErpContext.js"
import {
  TextField,
  Button,
  Typography,
  Box,
  Grid,
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Checkbox,
  Paper,
  IconButton,
  Modal,
  Card,
  CardContent,
  Divider,
  Chip,
  alpha,
  Alert,
  Fade,
  useTheme,
  InputAdornment,
  Tooltip,
} from "@mui/material"

import EditIcon from "@mui/icons-material/Edit"
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline"
import PercentIcon from "@mui/icons-material/Percent"
import ReceiptIcon from "@mui/icons-material/Receipt"
import ArrowForwardIcon from "@mui/icons-material/ArrowForward"
import ArrowBackIcon from "@mui/icons-material/ArrowBack"
import SaveIcon from "@mui/icons-material/Save"
import CloseIcon from "@mui/icons-material/Close"

const GestionImpuestoComponent = () => {
  const theme = useTheme()
  const {
    impuestos,
    getImpuestos,
    postImpuestos,
    updateImpuestoEstado,
    updateImpuestoContenido,
    getIncluirImpuestos,
    updateIncluirImpuestos,isNavbarCollapsed,
  } = useContext(ErpContext)

  const [descripcionImpuesto, setDescripcionImpuesto] = useState("")
  const [porcentajeImpuesto, setPorcentajeImpuesto] = useState("")
  const [checked, setChecked] = useState([])
  const [impuestosActivos, setImpuestosActivos] = useState([])
  const [impuestosEliminados, setImpuestosEliminados] = useState([])
  const [selectedImpuesto, setSelectedImpuesto] = useState(null)
  const [modalOpen, setModalOpen] = useState(false)
  const [editDescripcion, setEditDescripcion] = useState("")
  const [editPorcentaje, setEditPorcentaje] = useState("")
  const [checkedState, setCheckedState] = useState(false)
  const [loading, setLoading] = useState(false)
  const [success, setSuccess] = useState(false)
  const [error, setError] = useState(null)
  const [incluirImpuestos, setIncluirImpuestos] = useState(false)
  const [loadingIncluirImpuestos, setLoadingIncluirImpuestos] = useState(false)

  useEffect(() => {
    fetchImpuestos()
  }, [])

  const fetchImpuestos = async () => {
    setLoading(true)
    try {
      await getImpuestos()
    } catch (err) {
      console.error("Error al cargar impuestos:", err)
      setError("No se pudieron cargar los impuestos. Intente nuevamente.")
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    const fetchIncluirImpuestos = async () => {
      try {
        const result = await getIncluirImpuestos()
        result.valorParametro == 1 ? setIncluirImpuestos(true) : setIncluirImpuestos(false)
      } catch (err) {
        console.error("Error al obtener configuración de impuestos:", err)
      }
    }

    fetchIncluirImpuestos()
  }, [getIncluirImpuestos])

  const handleUpdateIncluirImpuestos = async () => {
    setLoadingIncluirImpuestos(true)
    try {
      await updateIncluirImpuestos(incluirImpuestos ? 2 : 1)
      setSuccess(true)
      setTimeout(() => setSuccess(false), 3000)
    } catch (err) {
      console.error("Error al actualizar configuración de impuestos:", err)
      setError("No se pudo actualizar la configuración de impuestos. Intente nuevamente.")
    } finally {
      setLoadingIncluirImpuestos(false)
    }
  }

  const handleEstadoToggle = async () => {
    setLoading(true)
    try {
      await updateImpuestoEstado(impuestosEliminados)
      setSuccess(true)
      setTimeout(() => setSuccess(false), 3000)
    } catch (err) {
      console.error("Error al actualizar estado de impuestos:", err)
      setError("No se pudo actualizar el estado de los impuestos. Intente nuevamente.")
    } finally {
      setLoading(false)
    }
  }

  const handleEditClick = (impuesto) => {
    setSelectedImpuesto(impuesto)
    setEditDescripcion(impuesto.descripcion)
    setEditPorcentaje(impuesto.porcentaje)
    setCheckedState(impuesto.incluidoEnPrecio)
    setModalOpen(true)
  }

  const handleModalSubmit = async () => {
    if (selectedImpuesto) {
      setLoading(true)
      try {
        // Mantener el valor original de incluidoEnPrecio (no permitir cambios)
        await updateImpuestoContenido(selectedImpuesto.id, editDescripcion, editPorcentaje, selectedImpuesto.incluidoEnPrecio)
        setModalOpen(false)
        setSuccess(true)
        setTimeout(() => setSuccess(false), 3000)
      } catch (err) {
        console.error("Error al actualizar impuesto:", err)
        setError("No se pudo actualizar el impuesto. Intente nuevamente.")
      } finally {
        setLoading(false)
      }
    }
  }

  // Dividir impuestos en activos y eliminados cada vez que se actualizan
  useEffect(() => {
    setImpuestosActivos(impuestos.filter((imp) => !imp.eliminado))
    setImpuestosEliminados(impuestos.filter((imp) => imp.eliminado))
  }, [impuestos])

  const handleImpuestoSubmit = async (e) => {
    e.preventDefault()
    if (!descripcionImpuesto.trim() || !porcentajeImpuesto) {
      setError("Por favor complete todos los campos")
      return
    }

    setLoading(true)
    try {
      await postImpuestos(descripcionImpuesto, porcentajeImpuesto)
      setDescripcionImpuesto("")
      setPorcentajeImpuesto("")
      setSuccess(true)
      setTimeout(() => setSuccess(false), 3000)
    } catch (err) {
      console.error("Error al agregar impuesto:", err)
      setError("No se pudo agregar el impuesto. Intente nuevamente.")
    } finally {
      setLoading(false)
    }
  }

  const handleToggle = (value) => () => {
    const currentIndex = checked.indexOf(value)
    const newChecked = [...checked]
    if (currentIndex === -1) {
      newChecked.push(value)
    } else {
      newChecked.splice(currentIndex, 1)
    }
    setChecked(newChecked)
  }

  const handleMoveToEliminados = () => {
    const updatedActivos = impuestosActivos.filter((imp) => !checked.includes(imp.id))
    const movedToEliminados = impuestosActivos.filter((imp) => checked.includes(imp.id))
    setImpuestosActivos(updatedActivos)
    setImpuestosEliminados([...impuestosEliminados, ...movedToEliminados])
    setChecked([])
  }

  const handleMoveToActivos = () => {
    const updatedEliminados = impuestosEliminados.filter((imp) => !checked.includes(imp.id))
    const movedToActivos = impuestosEliminados.filter((imp) => checked.includes(imp.id))
    setImpuestosEliminados(updatedEliminados)
    setImpuestosActivos([...impuestosActivos, ...movedToActivos])
    setChecked([])
  }

  const customList = (items, title) => (
    <Paper
      elevation={2}
      sx={{
        width: "100%",
        height: 300,
        overflow: "auto",
        borderRadius: 2,
        border: `1px solid ${alpha(theme.palette.divider, 0.1)}`,
      }}
    >
      <Box
        sx={{
          p: 2,
          backgroundColor: "#5b5b5f",
          color: "white",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
          {title}
        </Typography>
        <Chip label={`${items.length} items`} size="small" sx={{ color: "white" }} />
      </Box>
      <List dense component="div" role="list">
        {items.length > 0 ? (
          items.map((item) => {
            const labelId = `transfer-list-item-${item.id}-label`
            return (
              <ListItemButton
                key={item.id}
                role="listitem"
                onClick={handleToggle(item.id)}
                sx={{
                  "&:hover": {
                    backgroundColor: alpha(theme.palette.primary.main, 0.05),
                  },
                }}
              >
                <ListItemIcon>
                  <Checkbox
                    checked={checked.includes(item.id)}
                    tabIndex={-1}
                    disableRipple
                    inputProps={{ "aria-labelledby": labelId }}
                  />
                </ListItemIcon>
                <ListItemText
                  id={labelId}
                  primary={
                    <Box sx={{ display: "flex", alignItems: "center" }}>
                      <Typography variant="body2" sx={{ fontWeight: 500 }}>
                        {item.descripcion}
                      </Typography>
                      <Chip
                        label={`${item.porcentaje}%`}
                        size="small"
                        sx={{ ml: 1, bgcolor: alpha("rgb(244, 147, 14)", 0.1), color: "rgb(244, 147, 14)" }}
                      />
                      {item.incluidoEnPrecio && (
                        <Chip
                          label="Incluido"
                          size="small"
                          sx={{
                            ml: 1,
                            bgcolor: alpha(theme.palette.grey[400], 0.1),
                            color: theme.palette.grey[500],
                            opacity: 0.6,
                          }}
                        />
                      )}
                    </Box>
                  }
                />
              </ListItemButton>
            )
          })
        ) : (
          <ListItemText
            sx={{ p: 2 }}
            primary={
              <Typography color="text.secondary" align="center">
                No hay impuestos en esta categoría
              </Typography>
            }
          />
        )}
      </List>
    </Paper>
  )

  return (
    <Box sx={{ p: { xs: 1, sm: 2, md: 3 } }}>
      {/* Encabezado y formulario */}
      <Card
        elevation={2}
        sx={{
          mb: 3,
          borderRadius: 2,
          overflow: "visible",
        }}
      >
        <CardContent sx={{ p: 3 }}>
          <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
            <ReceiptIcon
              sx={{
                fontSize: 28,
                color: "rgb(244, 147, 14)",
                mr: 1.5,
              }}
            />
            <Typography variant="h5" component="h1" sx={{ fontWeight: 600 }}>
              Gestión de Impuestos
            </Typography>
          </Box>

          <Divider sx={{ mb: 3 }} />

          <form onSubmit={handleImpuestoSubmit}>
            <Grid container spacing={2} alignItems="center">
              <Grid item xs={12} md={5}>
                <TextField
                  label="Nombre del Impuesto"
                  variant="outlined"
                  fullWidth
                  value={descripcionImpuesto}
                  onChange={(e) => setDescripcionImpuesto(e.target.value)}
                  disabled={loading}
                  sx={{
                    "& .MuiOutlinedInput-root": {
                      borderRadius: 2,
                    },
                  }}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <ReceiptIcon color="action" />
                      </InputAdornment>
                    ),
                  }}
                />
              </Grid>
              <Grid item xs={12} md={5}>
                <TextField
                  label="Porcentaje"
                  variant="outlined"
                  fullWidth
                  type="number"
                  value={porcentajeImpuesto}
                  onChange={(e) => setPorcentajeImpuesto(e.target.value)}
                  disabled={loading}
                  sx={{
                    "& .MuiOutlinedInput-root": {
                      borderRadius: 2,
                    },
                  }}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <PercentIcon color="action" />
                      </InputAdornment>
                    ),
                    endAdornment: <InputAdornment position="end">%</InputAdornment>,
                  }}
                />
              </Grid>
              <Grid item xs={12} md={2}>
                <Button
                  variant="contained"
                  type="submit"
                  disabled={loading}
                  startIcon={<AddCircleOutlineIcon />}
                  sx={{
                    borderRadius: 2,
                    textTransform: "none",
                    boxShadow: 2,
                    minWidth: 140,
                    backgroundColor: "#5b5b5f",
                    "&:hover": {
                      backgroundColor: alpha("#5b5b5f", 0.9),
                    },
                  }}
                >
                  Agregar Impuesto
                </Button>
              </Grid>
            </Grid>
          </form>
        </CardContent>
      </Card>

      {/* Configuración global de impuestos */}
      <Card
        elevation={2}
        sx={{
          mb: 3,
          borderRadius: 2,
          overflow: "visible",
        }}
      >
        <CardContent sx={{ p: 3 }}>
          <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
            <ReceiptIcon
              sx={{
                fontSize: 24,
                color: "rgb(244, 147, 14)",
                mr: 1.5,
              }}
            />
            <Typography variant="h6" component="h2" sx={{ fontWeight: 600 }}>
              Configuración Global de Impuestos
            </Typography>
          </Box>

          <Divider sx={{ mb: 3 }} />

          <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
            <Box sx={{ display: "flex", alignItems: "center" }}>
              <Typography variant="body1" sx={{ mr: 2 }}>
                Default N
              </Typography>
              <Checkbox
                checked={incluirImpuestos}
                onChange={(e) => setIncluirImpuestos(e.target.checked)}
                color="primary"
                sx={{ mr: 1 }}
              />
              <Typography variant="body2" sx={{ fontStyle: "italic", color: "text.secondary" }}>
                {incluirImpuestos
                  ? "Se factura Default N"
                  : "No se factura Default N"}
              </Typography>
            </Box>
            <Button
              variant="contained"
              onClick={handleUpdateIncluirImpuestos}
              disabled={loadingIncluirImpuestos}
              startIcon={<SaveIcon />}
              sx={{
                borderRadius: 2,
                textTransform: "none",
                boxShadow: 2,
                backgroundColor: "#5b5b5f",
                "&:hover": {
                  backgroundColor: alpha("#5b5b5f", 0.9),
                },
              }}
            >
              Guardar Configuración
            </Button>
          </Box>
        </CardContent>
      </Card>

      {/* Alertas */}
      <Fade in={success}>
        <Alert
          severity="success"
          sx={{
            mb: 2,
            borderRadius: 2,
            boxShadow: 1,
          }}
          onClose={() => setSuccess(false)}
        >
          Operación completada con éxito
        </Alert>
      </Fade>

      {error && (
        <Alert
          severity="error"
          sx={{
            mb: 2,
            borderRadius: 2,
            boxShadow: 1,
          }}
          onClose={() => setError(null)}
        >
          {error}
        </Alert>
      )}

      {/* Sección de transferencia de impuestos */}
      <Card
        elevation={2}
        sx={{
          mb: 3,
          borderRadius: 2,
          overflow: "visible",
        }}
      >
        <CardContent sx={{ p: 3 }}>
          <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
            <ReceiptIcon
              sx={{
                fontSize: 24,
                color: "rgb(244, 147, 14)",
                mr: 1.5,
              }}
            />
            <Typography variant="h6" component="h2" sx={{ fontWeight: 600 }}>
              Administrar Estado de Impuestos
            </Typography>
          </Box>

          <Divider sx={{ mb: 3 }} />

          <Grid container spacing={2} alignItems="center">
            <Grid item xs={12} md={5}>
              {customList(impuestosActivos, "Impuestos Activos")}
            </Grid>
            <Grid item xs={12} md={2}>
              <Grid container direction="column" alignItems="center" spacing={2}>
                <Grid item>
                  <Button
                    variant="outlined"
                    size="small"
                    onClick={handleMoveToEliminados}
                    disabled={
                      checked.length === 0 || !checked.some((id) => impuestosActivos.some((imp) => imp.id === id))
                    }
                    startIcon={<ArrowForwardIcon />}
                    sx={{
                      borderRadius: 2,
                      textTransform: "none",
                      minWidth: 200,
                    }}
                  >
                    Mover a Eliminados
                  </Button>
                </Grid>
                <Grid item>
                  <Button
                    variant="outlined"
                    size="small"
                    onClick={handleMoveToActivos}
                    disabled={
                      checked.length === 0 || !checked.some((id) => impuestosEliminados.some((imp) => imp.id === id))
                    }
                    startIcon={<ArrowBackIcon />}
                    sx={{
                      borderRadius: 2,
                      textTransform: "none",
                      minWidth: 200,
                    }}
                  >
                    Mover a Activos
                  </Button>
                </Grid>
                <Grid item>
                  <Button
                    variant="contained"
                    onClick={handleEstadoToggle}
                    disabled={loading}
                    startIcon={<SaveIcon />}
                    sx={{
                      borderRadius: 2,
                      textTransform: "none",
                      boxShadow: 2,
                      minWidth: 200,
                      backgroundColor: "#5b5b5f",
                      "&:hover": {
                        backgroundColor: alpha("#5b5b5f", 0.9),
                      },
                    }}
                  >
                    Guardar Cambios
                  </Button>
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={12} md={5}>
              {customList(impuestosEliminados, "Impuestos Eliminados")}
            </Grid>
          </Grid>
        </CardContent>
      </Card>

      {/* Lista de todos los impuestos */}
      <Card
        elevation={2}
        sx={{
          borderRadius: 2,
          overflow: "hidden",
        }}
      >
        <CardContent sx={{ p: 3 }}>
          <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
            <ReceiptIcon
              sx={{
                fontSize: 24,
                color: "rgb(244, 147, 14)",
                mr: 1.5,
              }}
            />
            <Typography variant="h6" component="h2" sx={{ fontWeight: 600 }}>
              Todos los Impuestos
            </Typography>
            <Chip
              label={`Total: ${impuestos.length}`}
              size="small"
              sx={{ ml: 2, bgcolor: alpha("#5b5b5f", 0.1), fontWeight: 500 }}
            />
          </Box>

          <Divider sx={{ mb: 2 }} />

          <List sx={{ p: 0 }}>
            {impuestos.length > 0 ? (
              impuestos.map((impuesto) => (
                <Paper
                  key={impuesto.id}
                  elevation={1}
                  sx={{
                    mb: 1,
                    p: 2,
                    borderRadius: 2,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    backgroundColor: impuesto.eliminado ? alpha("#f5f5f5", 0.7) : "white",
                    "&:hover": {
                      backgroundColor: alpha(theme.palette.primary.main, 0.05),
                    },
                  }}
                >
                  <Box sx={{ display: "flex", alignItems: "center", flexGrow: 1 }}>
                    <Chip label={impuesto.id} size="small" variant="outlined" sx={{ mr: 2, minWidth: 40 }} />
                    <Typography variant="body1" sx={{ fontWeight: 500, mr: 2 }}>
                      {impuesto.descripcion}
                    </Typography>
                    <Chip
                      label={`${impuesto.porcentaje}%`}
                      size="small"
                      sx={{ mr: 2, bgcolor: alpha("rgb(244, 147, 14)", 0.1), color: "rgb(244, 147, 14)" }}
                    />
                    <Chip
                      label={impuesto.eliminado ? "Eliminado" : "Activo"}
                      size="small"
                      color={impuesto.eliminado ? "error" : "success"}
                      variant="outlined"
                      sx={{ mr: 2 }}
                    />
                    <Chip
                      label={impuesto.incluidoEnPrecio ? "Incluido en precio" : "No incluido"}
                      size="small"
                      color={impuesto.incluidoEnPrecio ? "info" : "default"}
                      variant="outlined"
                      sx={{
                        opacity: 0.6,
                        bgcolor: impuesto.incluidoEnPrecio ? alpha(theme.palette.grey[400], 0.1) : alpha(theme.palette.grey[300], 0.1),
                        color: theme.palette.grey[500],
                      }}
                    />
                  </Box>
                  <Tooltip title="Editar impuesto">
                    <IconButton
                      onClick={() => handleEditClick(impuesto)}
                      color="primary"
                      size="small"
                      sx={{
                        backgroundColor: alpha(theme.palette.primary.main, 0.1),
                        "&:hover": {
                          backgroundColor: alpha(theme.palette.primary.main, 0.2),
                        },
                      }}
                    >
                      <EditIcon fontSize="small" />
                    </IconButton>
                  </Tooltip>
                </Paper>
              ))
            ) : (
              <Typography color="text.secondary" align="center" sx={{ py: 3 }}>
                No hay impuestos registrados
              </Typography>
            )}
          </List>
        </CardContent>
      </Card>

      {/* Modal para editar el impuesto */}
      <Modal open={modalOpen} onClose={() => setModalOpen(false)}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: 400,
            bgcolor: "background.paper",
            borderRadius: 2,
            boxShadow: 24,
            p: 0,
            overflow: "hidden",
          }}
        >
          <Box
            sx={{
              p: 2,
              backgroundColor: "#5b5b5f",
              color: "white",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <Typography variant="h6" sx={{ display: "flex", alignItems: "center" }}>
              <EditIcon sx={{ mr: 1 }} /> Editar Impuesto
            </Typography>
            <IconButton onClick={() => setModalOpen(false)} sx={{ color: "white" }}>
              <CloseIcon />
            </IconButton>
          </Box>
          <Box sx={{ p: 3 }}>
            <TextField
              label="Nombre del Impuesto"
              variant="outlined"
              fullWidth
              value={editDescripcion}
              onChange={(e) => setEditDescripcion(e.target.value)}
              sx={{ mb: 2 }}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <ReceiptIcon color="action" />
                  </InputAdornment>
                ),
              }}
            />
            <TextField
              label="Porcentaje"
              variant="outlined"
              fullWidth
              type="number"
              value={editPorcentaje}
              onChange={(e) => setEditPorcentaje(e.target.value)}
              sx={{ mb: 3 }}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <PercentIcon color="action" />
                  </InputAdornment>
                ),
                endAdornment: <InputAdornment position="end">%</InputAdornment>,
              }}
            />
            <Box sx={{ display: "flex", alignItems: "center", mb: 3, opacity: 0.5 }}>
              <Typography variant="body1" sx={{ mr: 2 }}>
                Incluido en precio:
              </Typography>
              <Checkbox 
                checked={checkedState} 
                onChange={(e) => setCheckedState(e.target.checked)} 
                color="primary" 
                disabled={true}
              />
              <Typography variant="caption" sx={{ ml: 1, color: "text.secondary", fontStyle: "italic" }}>
                (Deshabilitado - Solo lectura)
              </Typography>
            </Box>
            <Box sx={{ 
              p: 1.5, 
              backgroundColor: alpha(theme.palette.warning.main, 0.1), 
              borderRadius: 1, 
              mb: 2,
              border: `1px solid ${alpha(theme.palette.warning.main, 0.3)}`
            }}>
              <Typography variant="caption" sx={{ color: theme.palette.warning.dark, fontSize: '0.75rem' }}>
                ℹ️ La configuración de "Incluido en precio" está deshabilitada. El valor se mantiene como está configurado actualmente.
              </Typography>
            </Box>
            <Button
              variant="contained"
              fullWidth
              onClick={handleModalSubmit}
              disabled={loading}
              startIcon={<SaveIcon />}
              sx={{
                borderRadius: 2,
                textTransform: "none",
                boxShadow: 2,
                backgroundColor: "#5b5b5f",
                "&:hover": {
                  backgroundColor: alpha("#5b5b5f", 0.9),
                },
              }}
            >
              Guardar Cambios
            </Button>
          </Box>
        </Box>
      </Modal>
    </Box>
  )
}

export default GestionImpuestoComponent
